import React from "react";
import { Helmet } from "react-helmet-async";
import Hero from "../components/Hero";
import PromoCapabilities from "../components/PromoCapabilities";
import Services from "../components/Services";
import CTA from "../components/CTA";

// 🔹 Reusable divider component
const Divider = ({ type = "horizontal" }) => {
  return type === "horizontal" ? (
    <div className="w-full h-[1px] bg-gradient-to-r from-transparent via-gray-300 dark:via-gray-700 to-transparent my-12 opacity-40 transition-colors duration-300" />
  ) : (
    <div className="h-full w-[1px] bg-gray-200 dark:bg-gray-800 opacity-20 mx-4 transition-colors duration-300" />
  );
};

const Home = () => {
  return (
    <div className="relative bg-white dark:bg-slate-900 transition-colors duration-300">
      <Helmet>
        <title>Blackbear Technologies Inc. | AI, Automation & Web Solutions</title>
        <meta
          name="description"
          content="Blackbear Technologies Inc. develops smart web platforms with AI, GPT integrations, process automations, and ERP consulting."
        />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://blackbeartechnologies.ca/" />
      </Helmet>

      {/* 🔲 Vertical Border Lines (Left & Right) */}
      <div className="absolute top-0 left-0 h-full w-[1px] bg-gray-200 dark:bg-gray-800 opacity-20 z-0 transition-colors duration-300" />
      <div className="absolute top-0 right-0 h-full w-[1px] bg-gray-200 dark:bg-gray-800 opacity-20 z-0 transition-colors duration-300" />

      {/* 🧠 Hero Section (AI Chat Banner) */}
      <Hero />

      {/* 🧩 Tightened spacing to Promo */}
      <div className="-mt-8 sm:-mt-12" />

      {/* 🚀 Capabilities Section */}
      <PromoCapabilities />

      {/* ➖ Divider */}
      <Divider />

      {/* 🛠️ Services Section */}
      <Services />

      {/* ➖ Divider */}
      <Divider />

      {/* 📣 Call To Action */}
      <CTA />
    </div>
  );
};

export default Home;
